const isValidExternalUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const validProtocols = ["http:", "https:"];
    if (!validProtocols.includes(urlObj.protocol)) {
      return false;
    }
    if (!urlObj.hostname) {
      return false;
    }
    return true;
  } catch (_error) {
    return false;
  }
};
const openBrowserExternalUrl = (url, target = "_blank") => {
  if (!isValidExternalUrl(url)) {
    console.error(`Invalid or unsafe URL provided: ${url}`);
    throw new Error(`Invalid or unsafe URL: ${url}`);
  }
  if (typeof document !== "undefined") {
    const anchorEl = document.createElement("a");
    anchorEl.style.display = "none";
    anchorEl.setAttribute("href", url);
    anchorEl.setAttribute("target", target);
    document.body.appendChild(anchorEl);
    anchorEl.click();
    document.body.removeChild(anchorEl);
  }
};

export { openBrowserExternalUrl };
//# sourceMappingURL=openBrowserExternalUrl.js.map
